import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { PlayerContext, PlayerTrack } from "@/types/player.type";

interface VideoPlayerStoreState {
  videoPlayer: HTMLVideoElement | undefined;
  hlsContext: PlayerContext | undefined;
  subtitles: Array<PlayerTrack> | undefined;
  audioTracks: Array<PlayerTrack> | undefined;
}
interface VideoPlayerStore extends VideoPlayerStoreState {
  setVideoPlayer: (videoPlayer: HTMLVideoElement | undefined) => void;
  setHlsContext: (hlsContext: PlayerContext | undefined) => void;
  setSubtitles: (subtitles: Array<PlayerTrack> | undefined) => void;
  setAudioTracks: (audioTracks: Array<PlayerTrack> | undefined) => void;
}

export const useVideoPlayerStore = create<VideoPlayerStore>()(
  devtools((set, _get) => ({
    videoPlayer: undefined,
    hlsContext: undefined,
    setVideoPlayer: (videoPlayer) => set({ videoPlayer: videoPlayer }),
    setHlsContext: (hlsContext) => set({ hlsContext: hlsContext }),
    setSubtitles: (subtitles) => set({ subtitles: subtitles }),
    setAudioTracks: (audioTracks) => set({ audioTracks: audioTracks }),
  })),
);
